// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export default (n, precision=2) => {
    if (n > 999999999)
        return "$" + (n/1000000000).toFixed(precision) + "B";

    if (n > 999999)
        return "$" + (n/1000000).toFixed(precision) + "M";

    if (n > 999)
        return "$" + (n/1000).toFixed(precision) + "k";

    if (n >= 0)
        return "$" + n.toFixed(precision);

    if (n > -1000)
        return "$(" + n.toFixed(precision) + ")";

    if (n > -1000000)
        return "$(" + (-n/1000).toFixed(precision) + "k)";

    if (n > -1000000000)
        return "$(" + (-n/1000000).toFixed(precision) + "M)";

    return "$(" + (-n/1000000000).toFixed(precision) + "B)";
}